import { ConfigProvider } from './../../providers/config-provider';
import { DomSanitizer } from '@angular/platform-browser';
import { AtividadeCadastroProgramaModel } from './../../models/atividade-cadastro-programa.model';
import { Congresso } from './../../models/congresso.model';
import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';
//Components
import { AuthProvider } from '../../providers/auth-provider';
import { CustomAlert } from '../../components/custom-alert.component';
import { VideoPlayerComponent } from './../../components/video-player/video-player.component';
//Providers
import { UtilProvider } from '../../providers/util-provider';
import { CongressoProvider } from '../../providers/congresso-provider';
import { User } from '../../models/user.model';

@Component({
    selector: 'page-video',
    templateUrl: 'video.html'
})
export class VideoPage {

    public atividade: AtividadeCadastroProgramaModel;
    public chat = undefined;
    public chatUrl: any = undefined;
    public isCurrent: boolean = true;

    public id: number;
    public title: string;
    public videoId: string;
    public urlVideo: any;
    public message: string;
    public viewed: boolean;
    public videoType: string;
    public palestrantes: Array<string>[];
    public user: User;

    public congresso: Congresso;
    private atividadesAssistidasIds: number[];

    constructor(private navParams: NavParams,
        public viewCtrl: ViewController,
        public dom: DomSanitizer,
        public utilProvider: UtilProvider,
        public videoPlayer: VideoPlayerComponent,
        private alert: CustomAlert,
        private auth: AuthProvider,
        private config: ConfigProvider,
        private congressoProvider: CongressoProvider) {

        this.atividade = this.navParams.get("atividade");
        this.user = JSON.parse(localStorage.getItem('user')) as User;
        this.id = this.navParams.get("id");
        this.title = this.navParams.get("title");
        this.urlVideo = this.navParams.get("url");
        this.message = this.navParams.get("message");
        this.viewed = this.isViewed();
        this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
        this.isCurrent = this.congresso.Ano == this.config.ANO_ATUAL || this.congresso.Liberado;
        this.atividadesAssistidasIds = localStorage.getItem('atividadesAssistidas') ? JSON.parse(localStorage.getItem('atividadesAssistidas')) as number[] : new Array<number>();

        this.setChat(this.urlVideo);
    }

    confirmView() {
        let self = this;

        if (self.utilProvider.isConnected(true) && this.auth.isAuthorized()) {
            self.viewed = !self.viewed;
            self.utilProvider.loadingShow();

            self.congressoProvider.confirmarVisualizacao(self.id, self.viewed)
                .then(res => {
                    self.utilProvider.loadingHide();
                    if (res.resposta.codigo == 0) {

                        self.viewed = res.resposta.retorno.Confirmou;

                        if (self.viewed) {
                            self.atividadesAssistidasIds.push(self.id);
                            localStorage.setItem('atividadesAssistidas', JSON.stringify(self.atividadesAssistidasIds));
                        }
                        else {
                            self.atividadesAssistidasIds = self.atividadesAssistidasIds.filter(x => x != self.id);
                            localStorage.setItem('atividadesAssistidas', JSON.stringify(self.atividadesAssistidasIds));
                        }
                    }
                    else if (res.resposta.codigo == -1 && res.resposta.retorno.error) {
                        self.viewed = false;
                        self.alert.showAlert('Atenção', res.resposta.retorno.error);
                    }
                    else if (res.resposta.retorno[0].error) {
                        self.viewed = false;
                        self.alert.showAlert('Atenção', res.resposta.retorno[0].error);
                    }
                })
                .catch(response => {
                    let err = response;
                    if (err) {
                        self.utilProvider.loadingHide();

                        self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
                    }
                });
                
        }
    }

    isViewed() {
        let self = this;
        return (localStorage.getItem('atividadesAssistidas') ? JSON.parse(localStorage.getItem('atividadesAssistidas')).some((x: number) => x == self.id) : false);
    }

    sinitize(url: string) {
        return this.dom.bypassSecurityTrustResourceUrl(url);
    }

    setChat(videoUrl: string) {
        let videoId = "";

        var regexYoutube = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]{11,11}).*/;
        if (videoUrl.match(regexYoutube)) {
            videoId = videoUrl.split(/v\/|v=|youtu\.be\//)[1].split(/[?&]/)[0];

            this.chat = 'https://www.youtube.com/live_chat?v=' + videoId + '&embed_domain=' + window.location.hostname;
            //Teste
            //this.chat = 'https://www.youtube.com/live_chat?v=lB1Q2Wlt6H8&embed_domain=' + window.location.hostname;
            this.chatUrl = this.sinitize(this.chat);
        }
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    checkPrescritor(){
        return this.user && this.user.Prescritor;
    }
}



// WEBPACK FOOTER //
// ./src/pages/video/video.ts